<template>
  <div class="page">
    <div class="page-header">
      <button class="header-nav-btn" @click="$parent.$refs.nav.open()" aria-label="Open nav menu"></button>

      <span class="page-title"><span class="icon">Partners</span></span>
      <HeaderNav />

      <button class="header-filter" @click="openFilters">Filter</button>
    </div>

    <div class="filter-notice" v-show="filtersActive && filterNoticeDescription.length">
      <p>Filtered by: <span>{{ filterNoticeDescription }}</span></p>
      <button class="clear" @click="clearFilters"></button>
    </div>

    <div v-if="pageData.acf" class="page-content">
      <Components :components="pageData.acf.components" location="above" />

      <div class="page-search" :class="pageData.acf.components.find(component => component.location === 'above' && component.acf_fc_layout !== 'page_intro') ? 'floating' : ''">
        <input type="text" v-model="search" v-on:keyup.enter="hideKeyboard" v-on:blur="hideKeyboard" v-on:focus="showKeyboard">
        <p class="input-placeholder" v-if="search.length === 0">Search</p>
        <button v-if="search.length" class="clear gray" @click="search = ''"></button>
      </div>

      <ul class="list" v-if="$root.app && partners.length">
        <CellPartner v-for="partner in partners" :partner="partner" :key="partner.id"></CellPartner>
      </ul>

      <div v-else class="page-container">
        <div class="bp-grid list-container" v-if="partners.length">
          <button v-for="partner in partners" :key="partner.id" class="bp" @click="$router.push(`/${$route.name}/${partner.id}`)">
            <div class="bp-content">
              <p v-if="partner.tour_side && partner.tour_side !== 'Unassigned'" class="tour-side">{{partner.tour_side}}</p>

              <img v-if="partner.featured_image" :src="partner.featured_image.url" :alt="partner.featured_image.alt">

              <h2 class="bp-name"><template v-if="partner.tour_number">{{partner.tour_number}}. </template>{{partner.business_name}}</h2>

              <div class="partner-location">
                <span class="tour-address">{{partner.tour_address}} {{partner.tour_address_2}}<br> {{partner.tour_city}} {{partner.tour_zip}}</span>
              </div>
            </div>
          </button>
        </div>
      </div>

      <p class="post-list" v-if="partners.length === 0 && (filtersActive || search.length)">No results</p>
      <p class="post-list" v-else-if="partners.length === 0">Loading...</p>

      <Components :components="pageData.acf.components" location="below" />
      <Footer />
    </div>

    <BPFilters :partners="partners" :selectedCategory="selectedCategory" ref="filters" />
  </div>
</template>

<script>
import SubPageUtils from '../mixins/SubPageUtils';
import FiltersUtils from '../mixins/FiltersUtils';

import Components from '../components/Components';
import HeaderNav from '../components/HeaderNav';
import Footer from '../components/Footer';
import CellPartner from '../components/CellPartner';

import BPFilters from "../components/BPFilters";

export default {
  name: 'Partners',
  components: { Components, HeaderNav, Footer, BPFilters, CellPartner },
  mixins: [SubPageUtils, FiltersUtils],
  data() {
    return {
      pageData: {},
      partnersData: [],
      selectedSide: '',
      selectedCategory: [],
    }
  },
  computed: {
    filterBySide() {
      if (this.selectedSide) {
        return this.partnersData.filter(partner => {
          return this.selectedSide.indexOf(partner.tour_side.toUpperCase()) > -1;
        });
      }

      return this.partnersData;
    },
    filterByCategory() {
      // Filter by filters
      if (this.selectedCategory.length) {
        let filter = this.filterBySide.filter(partner => {
          let hasFilter = false;
          this.selectedCategory.forEach((filter) => {
            if (partner.category.includes(filter)) {
              hasFilter = true;
              return;
            };
          });

          return hasFilter;
        });

        return filter;
      } else {
        return this.filterBySide;
      }
    },
    partners() {
      // Filter by search
      let search = this.filterByCategory.filter(partner => {
        let query = this.search.toLowerCase();
        let params;

        if (!query.length) return true;

        params = partner.business_name;
        params += ',' + partner.tour_address;
        params += ',' + partner.tour_address_2;
        params += ',' + partner.tour_zip;

        params = params.toLowerCase();

        return params.includes(query);
      });

      return search;
    },
    filtersActive() {
      return this.selectedCategory.length > 0;
    },
  },
  methods: {
  },
  async mounted() {
    const pageDataResponse = await fetch(`https://admin.austinstudiotour.org/wp-json/wp/v2/pages/18966`);
    this.pageData = await pageDataResponse.json();

    const bpResponse = await fetch(`${this.$root.api_url}getPartners`);
    this.partnersData = await bpResponse.json();
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.icon {
  background-image: url(../assets/img/icon-artists.svg);
  background-size: 18px 21px;
}

.page-search {
  position: relative;
  top: auto;
  left: auto;
  transform: none;
}

.bp-grid {
  @grid-layout-gap: 50px;
  @grid-column-count: 3;
  @grid-item--min-width: 300px;

  @gap-count: calc(@grid-column-count - 1);
  @total-gap-width: calc(@gap-count * @grid-layout-gap);
  @grid-item--max-width: calc(100% - (@total-gap-width) / @grid-column-count);

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(max(@grid-item--min-width, @grid-item--max-width), 1fr));
  grid-gap: (@grid-layout-gap);

  margin: 50px 0;
  .bp {
    text-decoration: none;
    &:hover {
      .bp-content .bp-name {
        color: @themeColor3;
      }
    }

    .bp-content {
      img {
        margin-bottom: 10px;
        max-width: 100%;
        height: 200px;
        object-fit: contain;
      }
      span,
      p,
      a {
        display: block;
        margin-bottom: 8px;
        color: #000;
        text-decoration: none;
      }
      p {
        margin-bottom: 20px;
        &.tour-side {
          margin-bottom: 5px;
          font-size: 13px;
          font-weight: bold;
          text-transform: uppercase;
          color: @themeColor3;
        }
      }
      .bp-name {
        margin-bottom: 5px;
        font-size: 24px;
        color: #000;
      }
      .partner-location {
        span {
          display: block;
        }
        a {
          color: #000;
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Partners.vue